
import { config as CONFIG } from '@platform/api'
import WithAutoFocus from '../../WithAutoFocus';
const { matchItemFocus } = WithAutoFocus.executeAutoFocus;

function findNextFocusItemInForm(nextModuleKeyMap, nextModuleId) {
  let wrapper = document.querySelector(`#${CONFIG.hotKeyModuleIdPrefix}-${nextModuleId}`);
  let formItem = wrapper.querySelector(`.${nextModuleKeyMap.firstItem}`);
  let type = getFormType(formItem);
  matchItemFocus[type] === undefined
    ? matchItemFocus['normal'](wrapper)
    : matchItemFocus[type](wrapper);
}

function findLastFocusItemInForm(nextModuleKeyMap, nextModuleId) {

}

function getFormType(formItem) {
  return Array.prototype.find.call(formItem.classList, function (item) {
    return item.startsWith('js-type');
  }).split('-')
    .pop();
}

export {
  findNextFocusItemInForm,
  findLastFocusItemInForm
};
